export default __webpack_public_path__ + "static/media/archived.f20e9e07.svg";